import { StyleSheet, Text, View, Image } from "react-native";
import React from "react";
import BackArrow from "../../../../components/BackArrow";
import { useNavigation } from "@react-navigation/native";
import { Category } from "../../../../components/DiscountsPerCategoryCard/categories";
import { SpecificCategoryScreenProps } from "../DiscountStack";
const CategoryHeader = ({ category }: { category: Category }) => {
  const navigation = useNavigation<SpecificCategoryScreenProps["navigation"]>();
  return (
    <View style={styles.header}>
      <BackArrow onPress={() => navigation.navigate("DiscountHome")} />
      <View style={styles.content}>
        <View style={styles.imageContainer}>
          <Image source={category.imgSrc} style={styles.image} />
        </View>
        <Text style={styles.text}>
          Descontos em {"\n"}
          <Text style={[styles.text, styles.bold]}>{category.category}</Text>
        </Text>
      </View>
    </View>
  );
};

export default CategoryHeader;

const styles = StyleSheet.create({
  header: {
    width: "100%",
    height: 165,
    backgroundColor: "#ffecb2",
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  imageContainer: {
    width: 71,
    height: 71,
    backgroundColor: "#fff",
    borderRadius: 35.5,
    alignItems: "center",
    justifyContent: "center",
    marginHorizontal: 15,
  },
  image: {
    width: 100,
    height: 100,
  },
  text: {
    fontSize: 25,
    lineHeight: 29,
  },
  bold: {
    fontWeight: "bold",
  },
});
